import CMSRichText from '../../../../Forms/Fields/richText'

const Footer = ({ footer, setFooter, isAddingNew, reportIndex }) => {
  return (
    <CMSRichText id={`footer${isAddingNew ? '_new_' : reportIndex}`} data={{}} value={footer} onChange={(value) => setFooter(value)}></CMSRichText>
  )
}
export default Footer
